import React from 'react';
import { Link } from 'gatsby';
import PostPreviewText from '~/components/PostPreviewText';
import Image from '~/components/Dynamic/Image';
import renderLink from '~/utils/render-link';

export default function PostPreview({ post, headingClass, imageClass }) {
  return post ? (
    <Link
      to={renderLink('/' + post?.full_slug)}
      className="flex flex-col flex-auto transition-opacity duration-150 ease-in-out hover:opacity-90"
    >
      <div className={`w-full mb-4 bg-light-grey ${imageClass || 'aspect-w-22 aspect-h-13'}`}>
        <div>
          <Image className="h-full w-full object-cover" blok={post?.content?.previewImage} />
        </div>
      </div>
      <PostPreviewText post={post} headingClass={headingClass} />
    </Link>
  ) : null;
}
